import * as angular from 'angular';
import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import {
  NavMenuService,
  HeaderSearchComponent,
  NavHomeLinksComponent,
  NavMenuContainerComponent,
  NavAccountMenuComponent,
  NavCollectionsComponent,
  NavDefinitionsComponent,
  ReportCreationMenuComponent,
} from '@mode/accounts/feature-header';

export const DowngradedAccountsFeatureHeaderModule = angular
  .module('downgraded-accounts-feature-header', [])
  .service('NavMenuService', downgradeInjectable(NavMenuService))
  .directive('modeHeaderSearch', downgradeComponent({ component: HeaderSearchComponent }))
  .directive('modeNavAccountMenu', downgradeComponent({ component: NavAccountMenuComponent }))
  .directive('modeNavCollections', downgradeComponent({ component: NavCollectionsComponent }))
  .directive('modeNavDefinitions', downgradeComponent({ component: NavDefinitionsComponent }))
  .directive('modeNavHomeLinks', downgradeComponent({ component: NavHomeLinksComponent }))
  .directive('modeNavMenuContainer', downgradeComponent({ component: NavMenuContainerComponent }))
  .directive('modeReportCreationMenu', downgradeComponent({ component: ReportCreationMenuComponent })).name;
